import { combineReducers } from 'redux';

import assetsReducer from './reducers/assetsReducer';
import burnRateReducer from './reducers/burnRateReducer';
import debtsReducer from './reducers/debtsReducer';
import exchangeRatesReducer from './reducers/exchangeRatesReducer';

const rootReducer = combineReducers({
  assets: assetsReducer,
  burnRate: burnRateReducer,
  debts: debtsReducer,
  exchangeRates: exchangeRatesReducer,
});

export default rootReducer;